import React from 'react';
import { node, string } from 'prop-types';

function InputSectionWrapper({ children, leftColumnContent, sectionId }) {
  return (
    <div className="mb-3 flex" id={sectionId}>
      <div className="flex w-16 justify-center pt-4 sm:w-32 sm:pt-2">
        {!!leftColumnContent && leftColumnContent}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
}

InputSectionWrapper.propTypes = {
  children: node.isRequired,
  leftColumnContent: node,
  sectionId: string,
};

InputSectionWrapper.defaultProps = {
  leftColumnContent: null,
  sectionId: 'sectionWrapper',
};

export default InputSectionWrapper;
